<div class="page-body">
  <div class="row">
    <!-- Right column start -->

    <div class="col-xl-3 col-lg-12 push-xl-9">
      <!-- Search box card start -->
      <div class="card">
        <div class="card-header">
          <h5 class="card-header-text">Search Box</h5>
        </div>
        <div class="card-body p-t-10">
          <div>
            <form
              [formGroup]="discussionSearchField"
              class="j-pro form-control md-float-material"
              id="j-pro"
            >
              <div class="j-input">
                <label class="j-icon-left" for="title">
                  <i class="icofont icofont-ui-search"></i>
                </label>
                <input
                  formControlName="term"
                  type="text"
                  id="term"
                  name="term"
                  placeholder="Search for a discussion"
                  class="name-group"
                  (keydown.enter)="$event.preventDefault()"
                />
              </div>
            </form>
          </div>

          <div>
            <ngb-accordion
              style="padding: 0px; margin: 0px"
              [closeOthers]="true"
              activeIds="static-1"
              class="ngb-accordion"
            >
              <ngb-panel id="static-1" style="padding: 0px; margin: 0px">
                <ng-template ngbPanelTitle>
                  <label class="j-icon-left" for="title">
                    <i class="icofont icofont-tag text-default"></i>
                  </label>
                  <h5 style="font-size: 14px; margin-right: 0px">
                    <a href="javascript:">Popular Tags</a>
                  </h5>
                </ng-template>
                <ng-template ngbPanelContent style="padding: 0px; margin: 0px">
                  <discussion-feed-tags
                    *ngFor="let tag of tags"
                    [tag]="tag"
                    (click)="setTagFeed(tag)"
                  >
                  </discussion-feed-tags>
                </ng-template>
              </ngb-panel>
            </ngb-accordion>
          </div>
        </div>
        <!-- end of card-body -->
      </div>
      <!-- Search box card end -->
    </div>
    <!-- Right column end -->

    <!-- Left column start -->
    <div class="col-xl-9 col-lg-12 pull-xl-3 filter-bar">
      <discussion-feed-nav-tabs
        [type]="config.type"
        [tag]="config.filters.tag"
        [discussionSearchTerm]="discussionSearchTerm"
        (setListTo)="setListTo($event)"
      >
      </discussion-feed-nav-tabs>
      <discussion-list [limit]="9" [config]="config"></discussion-list>
    </div>
    <!-- Left column end -->
  </div>
</div>
